<template>
  <div class="errPage-container">
    <el-button :icon="ArrowLeft" class="pan-back-btn" @click="logout">
      Logout
    </el-button>
    <el-row>
      <el-col :span="12">
        <h1 class="text-jumbo text-ginormous">403 Forbidden!</h1>
        <h2>You do not have required permissions!</h2>
        <ul class="list-unstyled">
          <li class="link-type">
            <p class="link-text" @click="accessGuide">
              Apply for access to CFES admin tool
            </p>
          </li>
        </ul>
      </el-col>
      <el-col :span="12">
        <img :src="errGifUrl" width="313" height="428" alt="403 Error" />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>

// TODO optimize page UI

import { computed } from "vue";
import { ArrowLeft } from "@element-plus/icons-vue";
import errGif from "@/assets/401_images/401.gif";
import { endSession } from "@/utils/session";

// Reactive data - computed to append timestamp for cache busting
const errGifUrl = computed(() => errGif + "?" + +new Date());

// Methods
const logout = () => {
  endSession();
};

const accessGuide = () => {
  const docUrl =
    "https://devstack.vwgroup.com/confluence/pages/viewpage.action?spaceKey=FOD&title=4.1+-+How+to+apply+for+CFES+kira+role";
  window.open(docUrl, "_blank");
};
</script>

<style lang="scss" scoped>
.errPage-container {
  width: 800px;
  max-width: 100%;
  margin: 100px auto;
  .pan-back-btn {
    background: #008489;
    color: #fff;
    border: none !important;
  }
  .pan-gif {
    margin: 0 auto;
    display: block;
  }
  .pan-img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  .text-jumbo {
    font-size: 60px;
    font-weight: 700;
    color: #484848;
  }
  .list-unstyled {
    font-size: 14px;
    line-height: 3rem;
    li {
      padding-bottom: 5px;
    }
    a {
      color: #008489;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .link-text {
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>
